import { useSelector } from 'react-redux';
import { getFeatureFromState } from '../stores/features';

const useGetFeature = name => {
  const features = useSelector(state => state.features);

  if (features.length === 0) {
    return null;
  }

  return getFeatureFromState(features, name);
};

export default useGetFeature;
